<template lang="pug">
  div.sidebar.bg-dark(:class="{ 'sidebar-visible': visible }")
    div
      button.close(type="button" @click="hideSidebar")
        span &times;
    div Suche nach Modelnummer oder Titel:
    input.form-control.form-control-lg(type="text" v-model="filterText")
    div.my-2 {{ productLines.length }} Produkt{{ productLines.length !== 1 ? 'e' : '' }} gefunden.
    div.results-view
      div.filter-result(
        v-for="(pl, px) in productLines" :key="px"
        @click="selectProductLine(pl)"
        :class="{ 'filter-result-active': selectedLine && pl.href === selectedLine.href }"
        )
        em {{ pl.productGroup }}
        br
        b {{ pl.modelNumberPattern }} {{ pl.title }}
</template>

<script>
export default {
  props: {
    filter: {
      type: String,
      required: true,
      default: ''
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    productLines: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedLine: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  data: () => ({
    filterText: ''
  }),
  watch: {
    filter: {
      handler (newVal) {
        this.filterText = newVal
      },
      immediate: true
    },
    filterText (newVal) {
      this.$emit('update:filter', newVal)
    }
  },
  methods: {
    hideSidebar () {
      this.$emit('update:visible', false)
    },
    selectProductLine (pl) {
      // something is selected, but scrolled away. I cannot click on it again because the watch in orderForm will get the same value
      // workaround: select empty and then the real one
      if (pl === this.selectedLine) {
        this.$emit('update:selectedLine', null)
      }
      // make sure that the empty update went through
      this.$nextTick(() => {
        this.$emit('update:selectedLine', pl)
      })
    }
  }
}
</script>
<style lang="stylus">
  .float-right
    float right

  .close
    float right
    color white

  .sidebar
    overflow hidden
    padding 16px
    position fixed
    top 0
    left calc(100% - 400px)
    bottom 0
    right 0
    height 100vh
    z-index 1040
    // background rgba(0, 0, 0, 0.75)
    color white
    transition all 0.3s
    margin-left 400px
    display flex
    flex-direction column

    &.sidebar-visible
      margin-left 0px

    div.results-view
      flex-grow 1
      overflow-y auto
      margin 0
      padding 0

    div.filter-result
      padding 4px
      color white
      cursor pointer

      &:hover
        color black
        background white

      &.filter-result-active
        color black
        background #ffd2eb

  @media (max-width: 1000px)
    .sidebar
      top 63px

</style>
